// Initialize Reviews.io product rating widgets for you may also like section
document.addEventListener('DOMContentLoaded', function() {
    function initYouMayAlsoLikeReviewsIOWidgets() {
        const ratingContainers = document.querySelectorAll('.you-may-also-like-section .product-rating[data-reviews-io-product-id]');
        
        if (ratingContainers.length === 0) return;

        // Check if Reviews.io script is already loaded
        if (window.ReviewsWidget) {
            ratingContainers.forEach(container => {
                createYouMayAlsoLikeRatingWidget(container);
            });
        } else {
            // Load Reviews.io script
            const script = document.createElement('script');
            script.src = 'https://widget.reviews.io/rating-snippet/dist.js';
            script.onload = function() {
                ratingContainers.forEach(container => {
                    createYouMayAlsoLikeRatingWidget(container);
                });
            };
            document.head.appendChild(script);
        }
    }
    
    function createYouMayAlsoLikeRatingWidget(container) {
        try {
            const productId = container.getAttribute('data-reviews-io-product-id');
            const store = container.getAttribute('data-reviews-io-store');
            
            // Check if we have valid data before creating widget
            if (!productId || !store) {
                container.style.display = 'none';
                return;
            }
            
            new ReviewsWidget({
                store: store,
                product: productId,
                widget: 'polaris',
                display_options: {
                    show_rating: true,
                    show_review_count: true,
                    show_review_text: false,
                    show_reviewer_name: false,
                    show_reviewer_avatar: false,
                    show_review_date: false
                },
                container: container
            });
        } catch (error) {
            // Hide container if widget fails
            container.style.display = 'none';
        }
    }
    
    // Initialize when DOM is ready
    initYouMayAlsoLikeReviewsIOWidgets();
});
